// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3pB_U","info":"PatientInfo_info__1Wo44"};